import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instance3dpz39ekmwtkx as RequestHook_instance,
  TransformRequestBodyHook_instance2rtk49v5zeoj1 as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance11jxsj1c494hm as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.z5p_1 = key;
        this.a5q_1 = client;
        this.b5q_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.c5q_1 = ArrayList().p2();
        var tmp_0 = this;
        tmp_0.d5q_1 = ClientPluginBuilder$onClose$lambda;
      }
      c5u(block) {
        this.e5q(RequestHook_instance, block);
      }
      v5v(block) {
        this.e5q(TransformRequestBodyHook_instance, block);
      }
      t5s(block) {
        this.e5q(TransformResponseBodyHook_instance, block);
      }
      e5q(hook, handler) {
        this.c5q_1.j2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
